import { render } from "./TestPage.vue?vue&type=template&id=50b0b6e9"
const script = {}

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__